import { render, staticRenderFns } from "./InterventionEditorDetails.vue?vue&type=template&id=35993d83"
import script from "./InterventionEditorDetails.vue?vue&type=script&lang=js"
export * from "./InterventionEditorDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports